export default {
  methods: {
    checkIfUserHasMoreThanOneAccount() {
      const accountData = localStorage.getItem("userHasMoreThanOneAccount");
      return JSON.parse(accountData);
    },
  },
};
